import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';

import { Observable, of, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable()
export class BrowserGlobalService {

  private customSubject = new Subject<any>();
  private lastSavedSection: number;

  browserBackObservable = this.customSubject.asObservable();
  GlobalLogout = "";


  constructor(private matDialog: MatDialog, private router: Router) { }


  get PreneedLastSavedSection(): number {
    return this.lastSavedSection;
  }

  set PreneedLastSavedSection(val: number) {
    this.lastSavedSection = val;
  }

  confirm(message?: string): Observable<boolean> {
    const confirmation = window.confirm(message || 'Are you sure?');
    return of(confirmation);
  };

  // Service message commands
  callComponentMethod(value: any) {
    this.customSubject.next(value);
  }

  navigateToTop(callback: () => any) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        callback();
      });
  }
}
